<template>
  <b-nav-item-dropdown variant="light" size="sm">
    <template #button-content>
      {{ user.name }}
    </template>
    <b-dropdown-item :to="{ name: 'home' }">
      <fa icon="home" />
      {{ $t('nav_home') }}
    </b-dropdown-item>

    <b-dropdown-item :to="{ name: 'settings.profile' }">
      <fa icon="cog" />
      {{ $t('settings') }}
    </b-dropdown-item>

    <b-dropdown-item v-if="user && user.admin" :to="{name: 'staticContents.index'}">
      <fa icon="edit" /> {{ $t('nav_edit_contents') }}
    </b-dropdown-item>

    <b-dropdown-divider />
    <b-dropdown-item @click.prevent="logout">
      <fa icon="sign-out-alt" />
      {{ $t('logout') }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UserDropdown',
  computed: mapGetters({
    user: 'auth/user'
  }),
  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>

</style>
